var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.show && _vm.tableColumnsMap && _vm.displayColumns
    ? _c(
        "el-popover",
        { attrs: { placement: "bottom-end", width: "200", trigger: "click" } },
        [
          _c(
            "p",
            {
              staticClass: "cursor-pointer flex items-center",
              staticStyle: { color: "#0c6fff", "font-size": "14px" },
              attrs: { slot: "reference" },
              slot: "reference",
            },
            [
              _c(
                "el-tooltip",
                {
                  staticClass: "item",
                  attrs: {
                    effect: "dark",
                    content: "自定义表头",
                    placement: "top-start",
                  },
                },
                [
                  _c("img", {
                    staticClass: "mr-1",
                    staticStyle: { "margin-top": "2px" },
                    attrs: { src: _vm.iconShezhi },
                  }),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "custom-table-header-popover" },
            [
              _c(
                "el-checkbox",
                {
                  attrs: {
                    disabled: _vm.allColumnsSelected,
                    indeterminate: _vm.allColumnsSelectedIndeterminate,
                  },
                  on: { change: _vm.handleCheckAllChange },
                  model: {
                    value: _vm.allColumnsSelected,
                    callback: function ($$v) {
                      _vm.allColumnsSelected = $$v
                    },
                    expression: "allColumnsSelected",
                  },
                },
                [_vm._v(" 全选 ")]
              ),
              _vm._l(_vm.displayColumns, function (item, index) {
                return [
                  index < _vm.displayColumns.length - 1 ||
                  (item.label !== "操作" && !item.disable)
                    ? _c(
                        "el-checkbox",
                        {
                          directives: [
                            {
                              name: "dragging",
                              rawName: "v-dragging",
                              value: {
                                item: item,
                                list: _vm.displayColumns,
                                group: _vm.keys || "item",
                              },
                              expression:
                                "{ item: item, list: displayColumns, group: keys || 'item' }",
                            },
                          ],
                          key: item.label,
                          attrs: { disabled: item.disable },
                          on: {
                            change: function ($event) {
                              return _vm.handleCheckedTableColumnsChange(item)
                            },
                          },
                          model: {
                            value: item.visible,
                            callback: function ($$v) {
                              _vm.$set(item, "visible", $$v)
                            },
                            expression: "item.visible",
                          },
                        },
                        [
                          _c("div", { staticClass: "labelItem" }, [
                            _vm._v(_vm._s(item.label)),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]
              }),
              _vm.displayColumns.length &&
              (_vm.displayColumns[_vm.displayColumns.length - 1].label ===
                "操作" ||
                _vm.displayColumns[_vm.displayColumns.length - 1].disable)
                ? _c(
                    "el-checkbox",
                    {
                      attrs: {
                        disabled:
                          _vm.displayColumns[_vm.displayColumns.length - 1]
                            .disable,
                      },
                      model: {
                        value:
                          _vm.displayColumns[_vm.displayColumns.length - 1]
                            .visible,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.displayColumns[_vm.displayColumns.length - 1],
                            "visible",
                            $$v
                          )
                        },
                        expression:
                          "displayColumns[displayColumns.length - 1].visible",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.displayColumns[_vm.displayColumns.length - 1]
                            .label
                        )
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            2
          ),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "permission",
                  rawName: "v-permission",
                  value: [_vm.permissionColumnsKey, _vm.permsList],
                  expression: "[permissionColumnsKey, permsList]",
                },
              ],
              attrs: { type: "primary", size: "mini" },
              on: { click: _vm.handleSave },
            },
            [_vm._v(" 设置为机构模板 ")]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }